import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import React, { useState, useEffect } from "react";
import SplitPane from "react-split-pane";

import "@ui5/webcomponents/dist/Assets.js";
import { ThemeProvider } from "@ui5/webcomponents-react/lib/ThemeProvider";
import MainNavigation from "./shared/components/Navigation/MainNavigation.js";
import Login from "./components/Login/page/Login";
import Home from "./components/Home/Home";
import {
  getToken,
  removeUserSession,
  getUser,
  getCompany,
  getCompanyDB
} from "./shared/utils/Common";
import FooterBar from "./shared/components/UIElements/FooterBar.js";
import RecommendationInfo from "./components/PayrunsApprovals/RecommendationInfo.js";
import SuppliersList from "./components/PayrunsApprovals/SuppliersList.js";
import DocumentDetails from "./components/PayrunsApprovals/DocumentDetails.js";
import RecommendationsList from "./components/PayrunsApprovals/RecommendationsList.js";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const user = getUser();
  const company = getCompany();
  const companyDB = getCompanyDB();
  const token = getToken();

  const handleAuthentication = {
    signin(cb) {
      setIsAuthenticated(true);
    },
    signout(cb) {
      setIsAuthenticated(false);
      removeUserSession();
    },
  };


  useEffect(() => {
    // When component is mounted
    if (getToken()) {
      handleAuthentication.signin();
    } else {
      handleAuthentication.signout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderLogin = () => {
    
    return (
      <Login
        login={handleAuthentication.signin}
        showLoginForm={!isAuthenticated}
      />
    );
  };

  return (
    <ThemeProvider withToastContainer>
      <BrowserRouter>
        <SplitPane
          split="vertical"
          minSize={50}
          defaultSize={localStorage.getItem("splitPos")}
          onChange={(size) => localStorage.setItem("splitPos", size)}
        >
          <MainNavigation
            isAuthenticated={isAuthenticated}
            handleLogout={handleAuthentication.signout}
            user={user}
            token={token}
          />
          <SplitPane
            split="horizontal"
            minSize={50}
            defaultSize={localStorage.getItem("splitPos")}
            onChange={(size) => localStorage.setItem("splitPos", size)}
          >
            <FooterBar />
            <Switch>
              <Route path="/" exact>
                {isAuthenticated ? (
                  <Home
                    user={user}
                    company={company}
                    token={token}
                    handleLogout={handleAuthentication.signout}
                  />
                ) : (
                  renderLogin
                )}
              </Route>
              <Route path="/login" exact>
                {renderLogin}
              </Route>
              <Route path="/approvals" exact>
                {isAuthenticated ? (
                  <RecommendationsList
                    company={company}
                    title={"Payment Recommendation Approval"}
                    companyDB={companyDB}
                    user={user}
                    setCompanyName={setCompanyName}
                    token={token}
                    handleLogout={handleAuthentication.signout}
                  />
                ) : (
                  renderLogin
                )}
              </Route>
              <Route path="/approvals/:approvalId" exact>
                {isAuthenticated ? (
                  <RecommendationInfo
                    user={user}
                    token={token}
                    handleLogout={handleAuthentication.signout}
                  />
                ) : (
                  renderLogin
                )}
              </Route>
              <Route path="/approvals/:approvalId/suppliers" exact>
                {isAuthenticated ? (
                  <SuppliersList
                    user={user}
                    company={company}
                    token={token}
                    handleLogout={handleAuthentication.signout}
                  />
                ) : (
                  renderLogin
                )}
              </Route>
              <Route path="/approvals/:approvalId/suppliers/:supplierId/docs">
                {isAuthenticated ? (
                  <DocumentDetails
                    company={companyName}
                    user={user}
                    token={token}
                    handleLogout={handleAuthentication.signout}
                  />
                ) : (
                  renderLogin
                )}
              </Route>
              <Redirect to="/" />
            </Switch>
          </SplitPane>
        </SplitPane>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
